import { useUserSession } from "./use-user-session";

/**
 * Returns the current authenticated user's id.
 * Backed by the shared `useUserSession` query so that this hook,
 * `useProjectId`, and `useUserRole` all share a single batched fetch.
 */
export function useCurrentUserId() {
  const session = useUserSession();
  return {
    ...session,
    data: session.data?.userId ?? null,
  } as ReturnType<typeof useUserSession> & { data: string | null };
}
